import { studioLocalDateTimeToIso } from './studioTime';

export function movableAppointment(a) {
  return Boolean(a?.id && ['scheduled', 'confirmed'].includes(a.status)
    && !a.rescheduled_to && !['processing', 'completed'].includes(a.checkout_status));
}

export function appointmentDuration(a) {
  return Number(a.duration_minutes) || Math.round((new Date(a.end) - new Date(a.start)) / 60000);
}

export function targetStart(day, offsetY, height, duration, timeZone) {
  if (!day || height <= 0 || offsetY < 0 || offsetY > height) return null;
  const minutes = 600 + Math.round(offsetY / height * 540 / 30) * 30;
  if (minutes < 600 || minutes + duration > 1140) return null;
  try {
    return studioLocalDateTimeToIso(`${day}T${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`, timeZone);
  } catch { return null; }
}

export function movePayload(a, start) {
  const duration = appointmentDuration(a);
  if (!movableAppointment(a) || !Number.isFinite(duration) || duration < 30 || duration > 600 || duration % 30) throw new Error('Appuntamento non spostabile.');
  if (!start || new Date(start) <= new Date()) throw new Error('Scegli un giorno e un orario futuri.');
  return { title: a.title || '', customer_id: a.customer_id || '', artist_id: a.artist_id || '',
    room_id: a.room_id || '', project_id: a.project_id || '', appointment_type: a.appointment_type || 'tattoo',
    service_type: a.service_type || a.appointment_type || 'tattoo', notes: a.notes || '', status: a.status,
    deposit: Number(a.deposit) || 0, duration_minutes: duration, start,
    end: new Date(new Date(start).getTime() + duration * 60000).toISOString(),
    smart_move: true, expected_start: a.start, expected_updated_at: a.updated_at ?? null };
}
